import { render, staticRenderFns } from "./MiniprogramLauncher.vue?vue&type=template&id=9ddf03ae"
import script from "./MiniprogramLauncher.vue?vue&type=script&lang=js"
export * from "./MiniprogramLauncher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports